import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { cn } from "@/utils/tailwind";
import { ComponentProps } from "react";

export function RadioGroup({
  className,
  ...props
}: ComponentProps<typeof RadioGroupPrimitive.Root>) {
  return (
    <RadioGroupPrimitive.Root
      data-slot="radio-group"
      className={cn("grid gap-3", className)}
      {...props}
    />
  );
}

export function RadioGroupItem({
  className,
  ...props
}: ComponentProps<typeof RadioGroupPrimitive.Item>) {
  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      className={cn(
        "flex items-center justify-center w-5 h-5 rounded-full border",
        "bg-transparent border-input text-white",
        "data-[state=checked]:bg-brand-500 data-[state=checked]:border-none",
        "focus-visible:ring-2 focus-visible:ring-brand-50 focus-visible:border-brand-200",
        "aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    >
      <span className="absolute flex items-center justify-center">
        <RadioGroupPrimitive.Indicator
          data-slot="radio-group-indicator"
          className="h-2 w-2 bg-white rounded-full"
        />
      </span>
    </RadioGroupPrimitive.Item>
  );
}
